import * as Styled from './error-text.styled'
export function ErrorText(): JSX.Element {
    return <Styled.Title>The requested CHR could not be found!</Styled.Title>
}
